import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import PlainLayout from "./layouts/PlainLayout";
import './assets/styles/main.scss';
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import Home from "./pages/Home";
import Proyects from "./pages/Proyects";
import History from "./pages/History";
import Events from "./pages/Events";
import Suit from "./pages/Suit";
import SuitPage from "./pages/SuitPage";
import Faq from "./pages/Faq";
import Donations from "./pages/Donations";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import A1z26 from "./pages/ciphers/a1z26";
import Binary from "./pages/ciphers/binary";
import Caesar from "./pages/ciphers/caesar";
import Hex from "./pages/ciphers/hex";
import Morse from "./pages/ciphers/morse";
import Octal from "./pages/ciphers/octal";
import Vigenere from "./pages/ciphers/vigenere";
import Test from "./pages/Test";
import Cards from "./pages/Cards";
import Apeiro from "./pages/Apeiro";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Loader />
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/proyectos" element={<Proyects />} />
          <Route path="/historia" element={<History />} />
          <Route path="/eventos" element={<Events />} />
          <Route path="/palos" element={<Suit />} />
          <Route path="/palos/:suit" element={<SuitPage />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/donaciones" element={<Donations />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/terminos-legales" element={<Legal />} />
          <Route path="/cifrados/a1z26" element={<A1z26 />} />
          <Route path="/cifrados/binario" element={<Binary />} />
          <Route path="/cifrados/cesar" element={<Caesar />} />
          <Route path="/cifrados/hexadecimal" element={<Hex />} />
          <Route path="/cifrados/morse" element={<Morse />} />
          <Route path="/cifrados/octal" element={<Octal />} />
          <Route path="/cifrados/vigenere" element={<Vigenere />} />
          <Route path="/test-palos" element={<Test />} />
          <Route path="/tcg" element={<Cards />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route element={<PlainLayout />}>
          <Route path="/apeiro" element={<Apeiro />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;